import { chordColors } from "@/utils/constants";

interface ChordButtonProps {
  chord: string;
  onClick?: (chord: string) => void;
  isInSong?: boolean;
}

const ChordButton = ({
  chord,
  onClick,
  isInSong = false,
}: ChordButtonProps) => {
  const chordBase = chord.substr(0, 1).toUpperCase();
  const chordColor = chordColors[chordBase];
  const textColor = isInSong ? "#000" : chordColor;
  const background = isInSong ? chordColor : null;
  return (
    <button
      type="button"
      className="btn btn-circle btn-sm leading-none text-sm font-medium mx-1 p-[6px]"
      onClick={() => onClick?.(chord)}
      style={{
        background: background || undefined,
        border: `1px solid ${chordColor}`,
        color: textColor,
      }}
    >
      {chord}
    </button>
  );
};
export default ChordButton;
